import { SpanStatusCode } from '@opentelemetry/api';
import {
  BASE_RDS,
  DEFAULT_RDS_PORT,
  RDS_READWEIGHT,
  RDS_SCALE_CONTROLLER,
} from 'src/common/helpers/config';
import XLRLogger from 'src/common/helpers/logger';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { getMetaData } from 'src/xlr-configuration/pos-service-type-utils';
import { axiosRequest } from '../../common/api/axios-request';
import { DeviceResponse } from '../rds-connection';

const loggerSource = 'devices/helper/read-weight.ts';

export const readWeight = async (timeout: number): Promise<DeviceResponse> => {
  const span = createSpan('[RDS] read-weight');
  try {
    const config = { params: { timeout } };
    const { RDS_PORT = DEFAULT_RDS_PORT, RDS_HOSTNAME = BASE_RDS } = getMetaData().xlrConfig;
    const response = await axiosRequest({
      url: `http://${RDS_HOSTNAME}:${RDS_PORT}${RDS_SCALE_CONTROLLER}${RDS_READWEIGHT}`,
      ...config,
    });
    endSpan(span);
    return response.data;
  } catch (error) {
    const deviceResponse: DeviceResponse = { success: false, metaDataMap: {} };
    deviceResponse.message = error.data.message;
    XLRLogger.error({
      message: error.data.message,
      source: loggerSource,
      data: undefined,
    });
    span.setStatus({
      code: SpanStatusCode.ERROR,
      message: `readWeight error: ${error.data.message}`,
    });
    return deviceResponse;
  }
};
